import sparePartsApi, {
  ApiResponse,
  getSparePartsData,
} from "../../../../api/spareParts.api";
import {
  DashboardAnalytics,
  InventoryAnalytics,
  MaintenanceAnalytics,
  ProcurementAnalytics,
  SparePartsDashboardData,
} from "../Dashboard.types";

type HubOption = {
  id: string;
  name: string;
  code?: string;
};

const hubLabel = (hub: HubOption) =>
  hub.code ? `${hub.name} (${hub.code})` : hub.name;

export const dashboardService = {
  getDashboard: () =>
    getSparePartsData<DashboardAnalytics>("/analytics/dashboard"),

  getInventory: () =>
    getSparePartsData<InventoryAnalytics>("/analytics/inventory"),

  getProcurement: () =>
    getSparePartsData<ProcurementAnalytics>("/analytics/procurement"),

  getMaintenance: () =>
    getSparePartsData<MaintenanceAnalytics>("/analytics/maintenance"),

  async getHubs() {
    const response =
      await sparePartsApi.get<ApiResponse<HubOption[]>>("/integrations/hubs");

    return response.data.data || [];
  },

  async getDashboardData(): Promise<SparePartsDashboardData> {
    const [dashboard, inventory, procurement, maintenance, hubs] =
      await Promise.all([
        this.getDashboard(),
        this.getInventory(),
        this.getProcurement(),
        this.getMaintenance(),
        this.getHubs(),
      ]);

    const hubNameById = new Map(hubs.map((hub) => [hub.id, hubLabel(hub)]));
    const attachHubName = <T extends { warehouseId: string }>(row: T) => ({
      ...row,
      warehouseName: hubNameById.get(row.warehouseId) || row.warehouseId,
    });

    return {
      dashboard,
      inventory: {
        ...inventory,
        stockAge: inventory.stockAge.map(attachHubName),
        deadStock: inventory.deadStock.map(attachHubName),
      },
      procurement,
      maintenance,
    };
  },
};
